<template>
  <div class="content">
    <div data-v-3cb7ae5b="" class="cardsDetail">
      <ul data-v-3cb7ae5b="" class="cards">
        <li data-v-3cb7ae5b="" v-for="(item, index) in cardLis" :key="index">
          <div data-v-3cb7ae5b="" class="card icbc">
            <div data-v-3cb7ae5b="" class="bank">
              <p data-v-3cb7ae5b="" class="iconName">
                <img data-v-3cb7ae5b="" :src="item.ico" alt="" class="bankIcon" /><span data-v-3cb7ae5b="" class="bankName">{{ item.bank }}</span>
              </p>
            </div>
            <p data-v-3cb7ae5b="" class="cardNum">{{ item.bank_owner }}</p>
            <p data-v-3cb7ae5b="" class="cardNum">{{ item.bank_no }}</p>

            <p data-v-3cb7ae5b="" class="rt" @click="delShow(item)">解绑</p>
          </div>
        </li>
      </ul>

      <div data-v-3cb7ae5b="" class="methods" v-if="cardLis.length < 5" @click="$parent.goNav('/addBankCard')">
        <a data-v-3cb7ae5b="" class="addBank"
          ><div data-v-3cb7ae5b="" class="icon"></div>
          <span data-v-3cb7ae5b="" class="title">添加银行卡</span></a
        >
      </div>
    </div>
      <div data-v-3cb7ae5b="" class="cardsDetail">
      <ul data-v-3cb7ae5b="" class="cards">
        <li data-v-3cb7ae5b="" v-for="(item, index) in usdssLis" :key="index">
          <div data-v-3cb7ae5b="" class="card icbc">
            <div data-v-3cb7ae5b="" class="bank">
              <p data-v-3cb7ae5b="" class="iconName">
                <span data-v-3cb7ae5b="" class="bankName">{{ item.bank }}</span>
              </p>
            </div>
            <p data-v-3cb7ae5b="" class="cardNum">{{ item.bank_owner }}</p>
            <p data-v-3cb7ae5b="" class="cardNum">{{ item.bank_no }}</p>

            <p data-v-3cb7ae5b="" class="rt" @click="delShow(item)">解绑</p>
          </div>
        </li>
      </ul>

      <div data-v-3cb7ae5b="" class="methods" v-if="usdssLis.length < 5" @click="$parent.goNav('/addUsdtCard')">
        <a data-v-3cb7ae5b="" class="addBank"
          ><div data-v-3cb7ae5b="" class="icon"></div>
          <span data-v-3cb7ae5b="" class="title">添加USDT</span></a
        >
      </div>
    </div>
    <div data-v-710c460e="" data-v-0dc57850="" @touchmove.prevent class="popup-background" v-if="delBox.id">
      <div data-v-0dc57850="" data-v-710c460e="" class="safety-popup">
        <div data-v-0dc57850="" data-v-710c460e="" class="popup">
          <div data-v-0dc57850="" data-v-710c460e="" class="pop-head">操作确认 <a data-v-0dc57850="" data-v-710c460e="" @click="closeDel" class="pop-close"></a></div>
          <div data-v-0dc57850="" data-v-710c460e="" class="pop-content">
            <p data-v-0dc57850="" data-v-710c460e="">您确定要删除</p>
            <p data-v-0dc57850="" data-v-710c460e="">{{ delBox.bank_no }}-{{ delBox.bank_owner }}</p>
            <p data-v-0dc57850="" data-v-710c460e="">吗？</p>
            <a data-v-0dc57850="" data-v-710c460e="" @click="isDelOk()" class="button">立即删除</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bankCard',
  data() {
    return { 
      usdssLis: [],
      cardLis: [], baseURL: '', delBox: {}, };
  },
  created() {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    that.getUsdssList();

    that.getcard();
  },
  methods: {
        getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
    delShow(item) {
      let that = this;
      that.delBox = item;
    },
    closeDel() {
      let that = this;
      that.delBox = {};
    },
    isDelOk() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/delcard', { id: that.delBox.id }).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.$parent.showTost(1, '解绑成功');
          that.delBox = {};
          that.getcard();
        that.getUsdssList();

        }
        that.$parent.hideLoading();
      });
    },
    getcard() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getcard', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-73f6d132.1840fe36.css';
.content .cardsDetail .cards li .card .rt[data-v-3cb7ae5b][data-v-eeb2b3bc] {
  width: 1.2rem;
  height: 0.5rem;
}
.content .cardsDetail .cards li .card .cardNum[data-v-3cb7ae5b][data-v-eeb2b3bc] {
  padding-bottom: 2px;
  padding-top: 10px;
  margin-top: 0px;
  font-size: 20px;
}
.popup-background[data-v-710c460e] {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/main/bankCard.vue